import React, { useCallback, useMemo } from 'react'
import { Box, Button } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useIdlePeriod } from 'src/Libs/smart-charge/hooks'
import { useField } from 'formik'
import { IdlePeriodStatusProcessingType } from 'src/Libs/smart-charge/types'
import { EmsIdlePeriodLegacyFormField } from 'src/Libs/smart-charge'

interface Props {
  /**
   * The form field name of the whole idlePeriod field list
   */
  fieldName: string
  disabled?: boolean
}
const IdlePeriodToggleAllAction: React.VFC<Props> = ({ fieldName, disabled = false }) => {
  const [field] = useField<EmsIdlePeriodLegacyFormField[]>(fieldName)
  const { t } = useCustomTranslation()
  const { toggleForSinglePeriodDialog } = useIdlePeriod(fieldName)

  const doActivation = useMemo<boolean>(() => {
    return field.value.findIndex(item => !(item.discharge.isActive || item.charge.isActive)) === 0
  }, [field.value])
  const expectedStatusProcessingType = useMemo<IdlePeriodStatusProcessingType>(() => (doActivation ? 'activate' : 'deactivate'), [doActivation])
  const toggleStatusLabel = useMemo<string>(
    () => (expectedStatusProcessingType === 'activate' ? t('common.activate') : t('common.deactivate')),
    [expectedStatusProcessingType, t]
  )

  const handleToggleStatus = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }

      toggleForSinglePeriodDialog(expectedStatusProcessingType)
    },
    [toggleForSinglePeriodDialog, expectedStatusProcessingType]
  )

  return (
    <Box sx={{ display: 'flex', height: '100%', flexDirection: 'column', justifyContent: 'center', mr: 5 }}>
      <Button variant={'text'} onClick={handleToggleStatus} disabled={disabled}>
        {toggleStatusLabel}
      </Button>
    </Box>
  )
}

export default IdlePeriodToggleAllAction
